import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=257567dc&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257567dc')) {
      api.createRecord('257567dc', component.options)
    } else {
      api.reload('257567dc', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=257567dc&", function () {
      api.rerender('257567dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/peach-pear-plum/views/dashboard.vue"
export default component.exports